import { createAuth0Client } from "@auth0/auth0-spa-js";

export default defineNuxtPlugin({
  name: "auth0",
  parallel: true,
  async setup(app) {
    const auth0Client = await createAuth0Client({
      domain: app.$config.public.auth0domain || "",
      clientId: app.$config.public.auth0clientId || "",
      authorizationParams: {
        redirect_uri: window.location.origin + "/auth",
      },
      // Persist tokens across page refreshes — avoids a full OAuth redirect on every reload.
      // The app already stores the access token in localStorage manually, so this does not
      // change the security posture.
      cacheLocation: "localstorage",
      useRefreshTokens: true,
    });

    return { provide: { auth0: auth0Client } };
  },
});
